<div class="solictud-recibida">
  <div class="left">
    <img src="./assets/img/hombre-celular.png" alt="Suscripción boleta electrónica satisfactoria" />
  </div>
  <div class="right">

    <h3 *ngIf="(codigo === '000' && mensaje === 'SUSCRIPCION EXITOSA' && solicitud === '')">
      ¡Gracias por suscribirte a<br>
      la boleta electrónica!*
    </h3>
    <h2 *ngIf="(codigo === '000') && solicitud !== ''">
      Hemos recibido exitosamente tu solicitud N° {{solicitud}}, la cual será procesada en un plazo de {{plazo}} días.
    </h2>
    <p>
      **En el caso de que tu próxima boleta ya esté impresa y/o despachada, la suscripción electrónica se hará efectiva
      desde el próximo periodo de facturación.
    </p>
    <input type="button" value="FINALIZAR" class="btn btn-finalizar" [routerLink]="['/home']">
  </div>
</div>
